import React from 'react'

import { HHFormSelectField, HHFormTextField } from 'components/form-fields/v5'
import T from 'T'

import type { HHFormSelectOption } from 'components/form-fields/v5/HHFormSelectField'
import type { Control } from 'react-hook-form'

export type LifecycleCaptureValues = {
  reasonId: string
  competitorId: string
  notes: string
}

type LifecycleCaptureFieldsProps = {
  control: Control<LifecycleCaptureValues>
  // Reason and competitor are asked only where the tenant has capture switched on; notes are for everyone.
  isReasonCaptured: boolean
  reasonLabel: string
  isReasonRequired: boolean
  reasonOptions: HHFormSelectOption[]
  reasonError?: string
  reasonHelperText?: string
  showCompetitor: boolean
  competitorOptions: HHFormSelectOption[]
  competitorError?: string
  onReasonChange: () => void
  onCompetitorChange: () => void
}

const LifecycleCaptureFields = ({
  control,
  isReasonCaptured,
  reasonLabel,
  isReasonRequired,
  reasonOptions,
  reasonError,
  reasonHelperText,
  showCompetitor,
  competitorOptions,
  competitorError,
  onReasonChange,
  onCompetitorChange,
}: LifecycleCaptureFieldsProps) => (
  <>
    {isReasonCaptured && (
      <HHFormSelectField
        fullWidth
        control={control}
        deprecatedLabel={false}
        error={reasonError}
        helperText={reasonHelperText}
        label={reasonLabel}
        name="reasonId"
        options={reasonOptions}
        required={isReasonRequired}
        onChange={onReasonChange}
      />
    )}
    {isReasonCaptured && showCompetitor && (
      <HHFormSelectField
        fullWidth
        required
        control={control}
        deprecatedLabel={false}
        error={competitorError}
        helperText={competitorError}
        label={T.COMPETITOR}
        name="competitorId"
        options={competitorOptions}
        onChange={onCompetitorChange}
      />
    )}
    <HHFormTextField fullWidth multiline control={control} deprecatedLabel={false} label={T.NOTES_OPTIONAL} minRows={2} name="notes" />
  </>
)

export default LifecycleCaptureFields
